import React from "react";
import { useLocation } from "@reach/router";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { CalendarRange } from "lucide-react";
import ScrollRevealWrapper from "@/components/utility/ScrollRevealWrapper";
import config from '@/utils/config';

const KeyDatesContent = ({ data }) => {

    const location = useLocation();
    const { sidebar } = config;

    const isSidebarPage =
    sidebar.enabled && sidebar.customPages.includes(location.pathname);
    const keyDates = data?.allStrapiEvent?.nodes[0]?.key_dates ?? [];

    return (
        <>
            {keyDates.length === 0 ? (
                <p className="text-base text-gray-200">No key dates available.</p>
            ) : (
                keyDates.map((item, index) => (
                    <div
                        key={index}
                        className={
                        isSidebarPage
                        ? "even:bg-slate-200 border-b px-4"
                        : ""
                    }>
                        <ScrollRevealWrapper className="py-3" delay={100 * index}>
                            <p className="text-xl pt-2 mb-2 font-medium">{item.title}</p>
                            <p className="text-base">{item.date}</p>
                        </ScrollRevealWrapper>
                    </div>
                ))
            )}
        </>
    );
};

export function KeyDates({ data }) {
    return <KeyDatesContent data={data} />;
}

export function KeyDatesModal({ data }) {
    return (
        <Sheet>
            <SheetTrigger className="fixed bottom-5 left-5 rounded-lg py-3 px-6 text-xl font-bold drop-shadow-lg hover:drop-shadow-xl flex items-center gap-2 uppercase bg-c1 text-white z-50">
                <CalendarRange />Key Dates
            </SheetTrigger>
            <SheetContent side="left" aria-describedby={undefined}>
                <SheetHeader>
                    <SheetTitle className="mb-0 pb-0 text-2xl font-bold">Key Dates</SheetTitle>
                    <SheetDescription asChild>
                        <KeyDatesContent data={data} />
                    </SheetDescription>
                </SheetHeader>
            </SheetContent>
        </Sheet>
    );
}
